module.exports = __webpack_public_path__ + "assets/img/abhijit-khan.8b4232de.jpg";